const laLigaContent = {
  preview: `La Liga 2024/25 continues to be defined by the eternal rivalry between Real Madrid and Barcelona. 
  With Carlo Ancelotti's Madrid side boasting the Champions League pedigree and Hansi Flick's Barcelona 
  showing signs of their classic tiki-taka revival, the title race promises to go down to the wire. 
  Atletico Madrid under Diego Simeone remain perennial dark horses, never to be underestimated.`,

  keyStories: [
    {
      title: "El Clasico Rivalry Renewed",
      desc: "Both Madrid and Barca have invested heavily, making their twice-yearly meetings even more consequential for the title race."
    },
    {
      title: "Yamal's Breakthrough Season",
      desc: "Lamine Yamal has emerged as one of world football's most exciting talents, drawing comparisons to Messi in his early Barcelona days."
    },
    {
      title: "Atletico's Defensive Fortress",
      desc: "Simeone's side concede fewest goals in the league, making every point dropped by the top two a potential title opportunity."
    },
  ],

  titleContenders: [
    "Real Madrid", "Barcelona", "Atletico Madrid", "Villarreal", "Athletic Club"
  ],

  fullPreview: `
    <h3>La Liga 2024/25 — Complete Season Analysis</h3>
    <p>Spanish football's top division continues to produce some of the world's most technically refined 
    football. La Liga's emphasis on technical ability, positional play, and tactical sophistication makes 
    it the preferred destination for coaches seeking to develop complete footballers.</p>
    
    <h3>Real Madrid — The Defending Champions</h3>
    <p>Carlo Ancelotti's side continue to blend experience with emerging talent. The Bernabeu remains 
    the most intimidating ground in European football on big European nights, and Madrid's ability to 
    perform in knockout competitions sets them apart.</p>
    
    <h3>Barcelona's Revival</h3>
    <p>Under Hansi Flick, Barcelona have rediscovered their identity. The German coach has instilled 
    an aggressive pressing game while maintaining the technical foundations that define the club's 
    football philosophy.</p>
    
    <h3>PitchFacts Prediction</h3>
    <p>Real Madrid's depth and European experience make them slight favorites, though Barcelona's 
    home form and Yamal's brilliance keep them firmly in contention throughout the season.</p>
  `,
};

export default laLigaContent;